import { Box } from '@rbilabs/universal-components';

export const Group = Box.withConfig({
  backgroundColor: Styles.color.cardBackground,
});
